import type { FaireProductEntity } from "../../entity_types/product";

export const p_dtrdtcv29f: FaireProductEntity = {
  token: "p_dtrdtcv29f",
  type: "product",
  name: "Palo Santo + Sage - 10oz Soy Candles",
  brandToken: "b_khkkpxpgu3",
  brandName: "6pm Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/de8bcd0685c6fd0a2c6a5130f879a1fae5ec0275914321b34f225548cc8c41b7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d5afa75763d7506f71911cbaf7982dd880e882285bc46b052930190dcbafc554.jpeg",
    "https://cdn.faire.com/fastly/e7c665523762cf5cadf984cde7bcab4b3b61ce778fbd7976bba75a42091ffb50.png",
  ],
  priceDollars: 22.5,
  description:
    "This gently scented cleansing palo santo and sage blend with grounding cedarwood and clove will fill your home with a fresh woodiness aroma.\n\nTop: Orange, Chinotto\nMiddle: Palo Santo, Clove, Cypress, Sage\nBase: Cedarwood, Black Wood\n\nAvailable in a beautiful recycled glass vessel or travel-friendly screwtop tin. \n\n10oz burn time: ~60 hours\n3.5oz burn time: ~20 hours ",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:03:54.415Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
